export const SIGN_IN = '/sign-in';
export const PASSWORD_FORGET = '/pw-forget';
export const HOME = '/';
export const ACCOUNT = '/account';
export const ADD_EVENT = '/addEvent';
export const EDIT_EVENT = '/events/:eventId';
export const POLLS = '/polls';